/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EventLogEntry = {
    timestamp: string;
    status: EventLogEntry.status;
    data?: Record<string, any>;
};
export namespace EventLogEntry {
    export enum status {
        OPEN = 'open',
        BOOKED = 'booked',
        ASSIGNED = 'assigned',
        APPROVED = 'approved',
        CANCELLED = 'cancelled',
        REJECTED = 'rejected',
        OUTAGE = 'outage',
        SKIPPED = 'skipped',
        MOVE_REQUESTED = 'move-requested',
    }
}

